import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Badge from "@mui/material/Badge";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MoreIcon from "@mui/icons-material/MoreVert";
import Logo from "../common/Logo";
import { DehazeOutlined } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import {
  getUserProfile,
  setLogoutAction,
} from "../../store/reducers/userSlice";
import { useSelector } from "react-redux";
import UserIcon from "../../assets/images/black_user.png";
import AssignNotificationIcon from "../../assets/svg/assign_notification.svg";
import {
  clearLeadDetails,
  setAllLeadListAction,
  setSingleLeadAction,
} from "../../store/reducers/leadSlice";
import CustomButton from "../common/button/CustomButton";
import { setAllTCDocumentListAction } from "../../store/reducers/documentSlice";
import { setAllFeedbackListAction } from "../../store/reducers/feedbackSlice";
import {
  getAssignNotificationMessageAction,
  getLeadNotificationMessageAction,
  getNotificationMessageAction,
} from "../../store/reducers/mmymSlice";
import { setFeedbackQuestionAction } from "../../store/reducers/customerFeedbackSlice";
import { setQuotationAction } from "../../store/reducers/customerSlice";
import { getConfirmationNotificationAction } from "../../store/reducers/clientConfirmationSlice";
import { Pagination, Tab, Tabs } from "@mui/material";
import {
  getSmsNotificationListAction,
  makrSmsReadResponse,
  markSmsReadAction,
} from "../../store/reducers/templateSlice";
interface HeaderProps {
  toggleSidebar: () => void;
}

const Header: React.FC<HeaderProps> = ({ toggleSidebar }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const location = useLocation(); // Get the current location
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] =
    React.useState<null | HTMLElement>(null);
  const [notificationAnchorE1, setNotificationAnchorE1] =
    React.useState<null | HTMLElement>(null);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const [isShowRedDot, setIsShowRedDot] = React.useState<any>(null);
  const [smsPage, setSmsPage] = React.useState(1);
  const { user, userProfile, isUserUpdateSuccess, permissions } = useSelector(
    (state: any) => state?.user,
  );

  console.log("userProfile", userProfile);
  console.log("permissions", permissions);
  // ✅ COMMON ROLE CHECK
  const isOwnerOrTenantOrAdmin =
    user?.user?.roles?.includes("Owner") ||
    user?.user?.roles?.includes("TENANT") ||
    user?.user?.roles?.includes("Admin");

  const { leadNotificationMessageList } = useSelector(
    (state: any) => state?.mmym,
  );

  const handleNotificationClick = (event: React.MouseEvent<HTMLElement>) => {
    setNotificationAnchorE1(event.currentTarget);
    const canReadNotification = permissions?.["Notification"]?.read === true;

    const canReadLead = permissions?.["Lead"]?.read === true;
    // Notification APIs should only be called when
    // the respective permission is true.

    if (canReadNotification) {
      dispatch(getNotificationMessageAction());
      dispatch(getSmsNotificationListAction({ page: 1, limit: 10 }));
    }
    
    if (canReadLead) {
      dispatch(getConfirmationNotificationAction());
      dispatch(getLeadNotificationMessageAction());
    }

    // Only mark notification as seen if user has permission
    if (canReadNotification || canReadLead) {
      localStorage.setItem("isSeenNotification", "true");
      setIsShowRedDot("true");
    }
  };

  const handleAssignNotificationClick = (
    event: React.MouseEvent<HTMLElement>,
  ) => {
    dispatch(
      getAssignNotificationMessageAction({ userId: user?.user?.staff_id }),
    );
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };


  const {
    smsNotificationLists,
    smsNotificationListPagination,
    isMarkSmsResponse,
  } = useSelector((state: any) => state.template);
  const { confirmationNotification } = useSelector(
    (state: any) => state?.confirmation,
  );
  console.log("smsNotificationLists", smsNotificationLists);
  React.useEffect(() => {
    const storedNotificationData = localStorage.getItem("isSeenNotification");
    if (storedNotificationData) {
      setIsShowRedDot(storedNotificationData);
    }
  }, []);

  const [formData, setFormData] = React.useState({
    userId: "",
    // sub:"",
    isLogoutAllDevices: false,
  });

  const [tabValue, setTabValue] = React.useState(0);

  const handleTabChange = (event: any, newValue: any) => {
    setTabValue(newValue);
  };

  React.useEffect(() => {
    if (userProfile && user) {
      setFormData({
        ...formData,
        // userId: userProfile?.id || userProfile?.staff_id,
        userId: user?.user?.sub,
      });
    }
  }, [userProfile, user]);

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleSignout = () => {
    dispatch(setLogoutAction(formData));
    setTimeout(() => {
      navigate("/");
      dispatch(clearLeadDetails());
      dispatch(
        setAllLeadListAction({ pagination: { currentPage: 1 }, list: [] }),
      );
      dispatch(setSingleLeadAction(null));
      dispatch(setAllTCDocumentListAction(null));
      dispatch(setAllFeedbackListAction([]));
      if (user?.user?.roles?.includes("CUSTOMER")) {
        dispatch(setFeedbackQuestionAction(null));
        dispatch(setQuotationAction(null));
      }
    }, 1500);
  };

  const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const navigateProfile = () => {
    navigate(`/profile`);
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  React.useEffect(() => {
    dispatch(getUserProfile());
  }, [dispatch]);

  const { notificationMessageList } = useSelector((state: any) => state?.mmym);

  const navigateSurveyDiary = () => {
    if (location.pathname === "/survey-diary") {
      navigate(`/dashboard`);
    } else {
      navigate(`/survey-diary`);
    }
  };
  React.useEffect(() => {
    if (isUserUpdateSuccess) {
      dispatch(getUserProfile());
    }
  }, [isUserUpdateSuccess]);

  // reset to page 1 each time the notification menu is freshly opened
  React.useEffect(() => {
    if (notificationAnchorE1) {
      setSmsPage(1);
    }
  }, [notificationAnchorE1]);

  const formatSmsDate = (dateString: string) => {
    if (!dateString) return "";
    const d = new Date(dateString);
    const pad = (n: number) => String(n).padStart(2, "0");
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(
      d.getHours(),
    )}:${pad(d.getMinutes())}`;
  };
  const handleMarkSmsRead = async (notification: any) => {
    if (notification?.unread === false) return; // already read, nothing to do
    try {
      await (
        dispatch(markSmsReadAction({ ids: [notification.id] })) as any
      ).unwrap();
    } catch (err) {
      console.error("Failed to mark SMS as read", err);
    } finally {
      dispatch(getSmsNotificationListAction({ page: smsPage, limit: 10 }));
    }
  };

  const handleMarkAllSmsRead = async () => {
    const unreadIds =
      smsNotificationLists
        ?.filter((n: any) => n?.unread)
        ?.map((n: any) => n.id) || [];

    if (unreadIds.length === 0) return;

    try {
      await (dispatch(markSmsReadAction({ ids: unreadIds })) as any).unwrap();
    } catch (err) {
      console.error("Failed to mark all SMS as read", err);
    } finally {
      dispatch(getSmsNotificationListAction({ page: smsPage, limit: 10 }));
    }
  };

  React.useEffect(() => {
    if (isMarkSmsResponse && smsPage) {
      dispatch(getSmsNotificationListAction({ page: smsPage, limit: 10 }));
      dispatch(makrSmsReadResponse(false));
    }
  }, [isMarkSmsResponse]);

  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      sx={{ mt: "45px" }}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem
        onClick={
          user?.user?.roles?.includes("CUSTOMER") ||
          user?.user?.roles?.includes("Customer")
            ? () => {}
            : navigateProfile
        }
      >
        <Box display="flex" flexDirection="column" alignItems="flex-start">
          <Typography sx={{ fontWeight: "bold" }}>
            {userProfile?.name}
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: "normal" }}>
            {userProfile?.email}
          </Typography>
        </Box>
      </MenuItem>
      <MenuItem onClick={handleSignout}>Sign out</MenuItem>
    </Menu>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem
        onClick={(e: any) => {
          handleMobileMenuClose();
          handleNotificationClick(e);
        }}
      >
        <IconButton size="large" color="inherit">
          <Badge
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            variant="dot"
            badgeContent={isShowRedDot === "true" ? 0 : " "}
            color="error"
          >
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );

  return (
    <Box sx={{ flexGrow: 1, background: "#008E72", color: "#fff" }}>
      <AppBar
        position="static"
        color="transparent"
        sx={{
          boxShadow: "0px 7px 13px 4px rgba(0,0,0,0.10)",
          paddingBottom: "10px",
        }}
      >
        <Toolbar>
          <Logo isPosition={false} isTitle={false} />
          {user?.user?.roles?.includes("TENANT") ||
          user?.user?.roles?.includes("Admin") ||
          !(
            user?.user?.roles?.length === 1 &&
            (user?.user?.roles[0] === "Surveyor" ||
              user?.user?.roles?.includes("CUSTOMER"))
          ) ? (
            <IconButton
              onClick={toggleSidebar}
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ ml: 0, position: "relative" }}
            >
              <DehazeOutlined />
            </IconButton>
          ) : (
            <>
              {!user?.user?.roles?.includes("Surveyor") ||
              !user?.user?.roles?.includes("Surveyor") ? (
                ""
              ) : (
                <CustomButton
                  style={{
                    marginLeft: "20px",
                    background: "#fff",
                    fontWeight: "600",
                    color: "#008e72",
                    cursor: "pointer",
                  }}
                  variant="outlined"
                  title={
                    location.pathname === "/survey-diary"
                      ? "Dashboard"
                      : "Survey Diary"
                  }
                  onClick={navigateSurveyDiary}
                />
              )}
            </>
          )}

          <Box sx={{ flexGrow: 1 }} />
          {/* {user?.user?.roles?.includes("CUSTOMER") ||
          user?.user?.roles?.includes("Customer") ? (
            ""
          ) : (
            <CustomSearchBar />
          )} */}

          <Box sx={{ flexGrow: 1 }} />
          <Typography
            sx={{
              marginRight: "8px",
              fontWeight: 600,
              display: { xs: "none", md: "flex" },
            }}
          >
            {userProfile?.companyName ?? ""}
          </Typography>
          {(isOwnerOrTenantOrAdmin ||
            permissions?.["Notification"]?.read ||
            permissions?.["Lead"]?.read) && (
            <>
              <Box sx={{ display: { xs: "none", md: "flex" } }}>
                <IconButton
                  size="large"
                  aria-label="show new notifications"
                  color="inherit"
                  onClick={handleNotificationClick}
                >
                  <Badge
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    variant="dot"
                    badgeContent={isShowRedDot === "true" ? 0 : " "}
                    color="error"
                  >
                    <NotificationsIcon />
                  </Badge>
                </IconButton>

                <Menu
                  anchorEl={notificationAnchorE1}
                  open={Boolean(notificationAnchorE1)}
                  onClose={() => setNotificationAnchorE1(null)}
                  sx={{
                    marginTop: "60px",
                    padding: "20px",
                    "& .MuiPaper-root": {
                      // boxShadow: 'none',
                      width: "500px",
                      height:
                        notificationMessageList?.length > 10 ? "528px" : "auto",
                      overflowY: "auto",
                      borderRadius: "10px !important",
                    },
                    "& .MuiList-root": {
                      paddingBottom: 0,
                    },
                  }}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                >
                  {/* Tabs Header */}
                  <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    variant="fullWidth"
                  >
                    {(isOwnerOrTenantOrAdmin ||
                      permissions?.["Lead"]?.read) && (
                      <Tab label="Confirmations" />
                    )}
                    {/* <Tab label="Notifications" /> */}
                    {(isOwnerOrTenantOrAdmin ||
                      permissions?.["Lead"]?.read) && (
                      <Tab label="Lead Notifications" />
                    )}
                    {(isOwnerOrTenantOrAdmin ||
                      permissions?.["Notification"]?.read) && (
                      <Tab
                        label={
                          <span>
                            SMS
                            <span style={{ fontSize: "0.7em" }}>s</span>
                          </span>
                        }
                      />
                    )}
                  </Tabs>

                  {/* Tab 1: Regular Notifications */}
                  {tabValue === 1 && (
                    <Box sx={{ padding: "10px 16px" }}>
                      {leadNotificationMessageList?.notifications?.length >
                      0 ? (
                        leadNotificationMessageList?.notifications.map(
                          (notification: any) => (
                            <MenuItem
                              sx={{
                                marginTop: "10px",
                                padding: "8px",
                                whiteSpace: "wrap",
                                borderRadius: 0,
                                backgroundColor:
                                  notification?.color || "#EAE9EA",
                                margin: 0,
                                textAlign: "left !important",
                                borderTop: "2px solid #C8C9C9",
                              }}
                              key={notification.id}
                            >
                              <Typography>{notification.message}</Typography>
                            </MenuItem>
                          ),
                        )
                      ) : (
                        <Typography sx={{ padding: "16px" }}>
                          No Notification Found
                        </Typography>
                      )}
                    </Box>
                  )}

                  {/* Tab 2: Confirmation Notifications */}
                  {tabValue === 0 && (
                    <Box sx={{ padding: "10px 16px" }}>
                      {confirmationNotification?.length > 0 ? (
                        confirmationNotification.map(
                          (notification: any, index: any) => (
                            <MenuItem
                              key={index}
                              sx={{
                                marginTop: "10px",
                                padding: "16px",
                                whiteSpace: "wrap",
                                borderRadius: 0,
                                backgroundColor: "#EAE9EA",
                                margin: 0,
                                textAlign: "left !important",
                                borderTop: "2px solid #C8C9C9",
                              }}
                              onClick={() => {
                                setNotificationAnchorE1(null); // ⬅️ Close the menu
                                const leadId = notification?.lead_id;
                                sessionStorage.setItem(
                                  "selectedJobLeadId",
                                  JSON.stringify(Number(leadId)),
                                );
                                setTimeout(() => {
                                  navigate("/dashboard");
                                }, 100);
                              }}
                            >
                              <Typography>
                                Lead <b>{notification?.name}</b> has been
                                successfully confirmed by the customer.
                              </Typography>
                            </MenuItem>
                          ),
                        )
                      ) : (
                        <Typography sx={{ padding: "16px" }}>
                          No Confirmation Found
                        </Typography>
                      )}
                    </Box>
                  )}

                  {/* Tab 3: SMS Notifications */}
                  {tabValue === 2 && (
                    <Box sx={{ padding: "10px 16px" }}>
                      {smsNotificationLists?.length > 0 ? (
                        <>
                          {/* Mark all as read - top of list */}
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "flex-end",
                              padding: "4px 4px 12px",
                            }}
                          >
                            <Typography
                              variant="body2"
                              onClick={handleMarkAllSmsRead}
                              sx={{
                                color: "#008E72",
                                fontWeight: 600,
                                cursor: "pointer",
                                "&:hover": { textDecoration: "underline" },
                              }}
                            >
                              Mark all as read
                            </Typography>
                          </Box>

                          {smsNotificationLists.map(
                            (notification: any, index: number) => {
                              const isUnread = notification?.unread === true;
                              return (
                                <Box
                                  key={notification?.id ?? index}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    gap: "12px",
                                    padding: "12px 16px",
                                    backgroundColor: isUnread
                                      ? "#D9F3FB"
                                      : "#EAE9EA",
                                    borderLeft: isUnread
                                      ? "4px solid #1BA8D5"
                                      : "4px solid transparent",
                                    borderTop: "2px solid #C8C9C9",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setNotificationAnchorE1(null);
                                    sessionStorage.setItem(
                                      "selectedJobLeadId",
                                      JSON.stringify(
                                        Number(notification?.lead_id),
                                      ),
                                    );
                                    setTimeout(
                                      () => navigate("/dashboard"),
                                      100,
                                    );
                                  }}
                                >
                                  <Box>
                                    <Typography
                                      sx={{ fontWeight: 500, color: "#333" }}
                                    >
                                      {notification?.actor_name}{" "}
                                      {notification?.lead_id} responded
                                    </Typography>
                                    <Typography
                                      variant="caption"
                                      sx={{ color: "#8a8a8a" }}
                                    >
                                      {formatSmsDate(notification?.created_at)}
                                    </Typography>
                                  </Box>

                                  <Box
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleMarkSmsRead(notification);
                                    }}
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "6px",
                                      backgroundColor: "#fff",
                                      borderRadius: "20px",
                                      padding: "6px 14px",
                                      cursor: "pointer",
                                      boxShadow: "0px 1px 3px rgba(0,0,0,0.15)",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {isUnread ? (
                                      <RadioButtonUncheckedIcon
                                        sx={{ color: "#008E72", fontSize: 20 }}
                                      />
                                    ) : (
                                      <CheckCircleIcon
                                        sx={{ color: "#008E72", fontSize: 20 }}
                                      />
                                    )}
                                    <Typography variant="body2">
                                      {isUnread ? "Mark read" : "Read"}
                                    </Typography>
                                  </Box>
                                </Box>
                              );
                            },
                          )}

                          {/* Pagination - always shown when API reports more than 1 page */}
                          {smsNotificationListPagination?.totalPages > 1 && (
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                padding: "16px 0 4px",
                              }}
                            >
                              <Pagination
                                count={smsNotificationListPagination.totalPages}
                                page={smsPage}
                                onChange={(_e, value) => {
                                  setSmsPage(value);
                                  dispatch(
                                    getSmsNotificationListAction({
                                      page: value,
                                      limit: 10,
                                    }),
                                  );
                                }}
                                color="primary"
                                size="small"
                                shape="rounded"
                              />
                            </Box>
                          )}
                        </>
                      ) : (
                        <Typography sx={{ padding: "16px" }}>
                          No SMS Found
                        </Typography>
                      )}
                    </Box>
                  )}
                </Menu>
              </Box>

              {/* assign notification icon AssignNotificationIcon */}
              {/* <Box sx={{ display: { xs: "none", md: "flex" } }}>
                <IconButton
                  size="large"
                  aria-label="show new notifications"
                  color="inherit"
                  onClick={handleAssignNotificationClick}
                >
                  <img
                    src={AssignNotificationIcon}
                    alt="profile"
                    style={{ height: "30px", width: "30px" }}
                  />
                </IconButton>

                <Menu
                  anchorEl={notificationAnchorE1}
                  open={Boolean(notificationAnchorE1)}
                  onClose={() => setNotificationAnchorE1(null)}
                  sx={{
                    marginTop: "60px",
                    padding: "20px",
                    "& .MuiPaper-root": {
                      width: "500px",
                      height:
                        notificationMessageList?.length > 10 ? "528px" : "auto",
                      overflowY: "auto",
                      borderRadius: "10px !important",
                    },
                    "& .MuiList-root": {
                      paddingBottom: 0,
                    },
                  }}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                >
                  <Box sx={{ padding: "10px 16px" }}>
                    {notificationMessageList?.length > 0 ? (
                      notificationMessageList.map((notification: any) => (
                        <MenuItem
                          sx={{
                            marginTop: "10px",
                            padding: "16px",
                            whiteSpace: "wrap",
                            borderRadius: 0,
                            backgroundColor: "#EAE9EA",
                            margin: 0,
                            textAlign: "left !important",
                            borderTop: "2px solid #C8C9C9",
                          }}
                          key={notification.id}
                        >
                          <Typography>{notification.message}</Typography>
                        </MenuItem>
                      ))
                    ) : (
                      <Typography sx={{ padding: "16px" }}>
                        No Notification Found
                      </Typography>
                    )}
                  </Box>
                </Menu>
              </Box> */}
            </>
          )}

          <Box sx={{ display: { xs: "none", md: "flex" } }}>
            <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              // color="inherit"
            >
              <img
                src={userProfile?.logo ? userProfile?.logo : UserIcon}
                alt="profile"
                style={{ height: "36px", width: "36px" }}
              />
            </IconButton>
          </Box>

          <Box sx={{ display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
    </Box>
  );
};
export default Header;
